import React, { FC } from 'react';
import { Link } from '@lululemon/b2b-ecom-pattern-library';
import { storeIcon } from '@lululemon/ui-icons';
import cs from 'classnames';
import { useBusinessUnit } from 'frontastic';
import styles from '../top-nav-desktop/top-nav-desktop-bar.module.scss';

const BusinessUnitName: FC = () => {
  const { businessUnit } = useBusinessUnit();

  const businessUnitName =
    businessUnit?.name && businessUnit?.custom?.fields?.partner_key
      ? `${businessUnit.name}, ${businessUnit.custom.fields.partner_key}`
      : '';

  return (
    <Link
      data-testid="top-nav-shipping-location"
      className={cs('flex cursor-pointer', 'lll-type-body-small', styles.busuinessLink)}
      icon={storeIcon}
      id="top-nav-shipping-location"
      tag="div"
      variant="secondary"
    >
      {businessUnitName}
    </Link>
  );
};

export default BusinessUnitName;
